import React from 'react';
import { SetNewPasswordProvider } from './SetNewPasswordContext';
import Container from './Container';

const SetNewPasswordContent = () => {
  return (
    <SetNewPasswordProvider>
      <Container />
    </SetNewPasswordProvider>
  );
};

export default SetNewPasswordContent;
